'use strict'

document.addEventListener('DOMContentLoaded', () => {
    /*********************************
     * move wishlist to slider
     ********************************/
    let checkWishlist = 0;
    const mainSlider = document.querySelector('.product-media__slider-swiper');

    if (mainSlider) {
        const productTitleWrapper = document.querySelector('.product-title-wrapper');
        const startInterval = () => {
            const interval = setInterval(() => {
                try {
                    checkWishlist++;
                    const wishList = document.querySelector('#wishlisthero-product-page-button-container');

                    if (checkWishlist > 10) {
                        clearInterval(interval);
                    }

                    if (!wishList) {
                        throw new Error('wishList block is not defined');
                    }

                    if(window.innerWidth < 1024){
                        //document.querySelector('.product-media__slider-swiper').append(wishList);
                    }else{
                       // productTitleWrapper.append(wishList);
                    }

                    wishList.classList.add('show-wishlist');
                    clearInterval(interval);

                } catch (error) {

                }
            }, 1000);
        };
        startInterval();
    }

    /*********************************
     * position slider navigation on tablet and mobile
     ********************************/
    const mainProductSwiper = document.querySelector('.product-main-slider');

    if(mainProductSwiper && window.innerWidth < 1024){
        const swiperPagination = mainProductSwiper.querySelector('.swiper-pagination');
        const productSingleMedia = mainProductSwiper.querySelector('.product-single__media');
        swiperPagination.style.top = `${productSingleMedia.offsetHeight - 25}px`;
        swiperPagination.classList.add('show-pagination');
    }

    /*********************************
     * move custom swatch selector
     ********************************/
    const customSwatchSelector = document.querySelector('.product__selectors');
    const defaultSwatchSelector = document.querySelector('.product__block--switches');

    if(customSwatchSelector && defaultSwatchSelector) {
        const swatchClone = customSwatchSelector.cloneNode(true);
        document.querySelector('.product__price-and-badge-mobile').after(swatchClone);

        swatchClone.classList.add('show-custom-swatch');
        defaultSwatchSelector.style.display = 'none';

        swatchClone.querySelectorAll('.swatch__button').forEach((swatch, index) =>{
            const inputId = swatch.querySelector('input').getAttribute('id');
            swatch.querySelector('input').setAttribute('id', `swatch-${index}`);
            swatch.querySelector('label').setAttribute('for', `swatch-${index}`);
            swatch.querySelector('input').setAttribute('name', `customSwatch`);
            swatch.querySelector('label').setAttribute('swatch-id', inputId);
        });

        swatchClone.addEventListener('click',  ({target})=> {
            if(target.classList.contains('swatch__label')){
                const productFormWrapper = document.querySelector('.product__form__wrapper');
                const getId = target.getAttribute('swatch-id');

                productFormWrapper.querySelector(`label[for="${getId}"]`).click();
            }
        });

    }else if (customSwatchSelector){
        customSwatchSelector.classList.add('show-default-position');
    }

    /*** label ***/
    let allCircles = document.querySelectorAll('.swatch__button--circle');
    let circleLabels = document.querySelectorAll('.radio__legend__label--value');

    allCircles.forEach((element) => {
        element.addEventListener('click', () => {
            allCircles.forEach((element1) => {
                element1.classList.remove('active');
            });
            element.classList.add('active');
            circleLabels.forEach((el) => {
              //  el.style.display = 'none';
            });

            element.closest('div').querySelector('.radio__legend__label--value').style.display = 'inline-block';
        });
    });

    /*** Replace alt text: #color_ ***/
    /*const productAltText = document.querySelectorAll('.product-single__alt-text');
    if(productAltText.length >= 1){
        productAltText.forEach(altText =>{
            const content = altText.textContent;
            const regex = /#color_[^\s]+/g;

            if (regex.test(content)) {
                const newText = content.replace(regex, '');
                altText.textContent = newText;
            }

            altText.classList.add('show');
        });
    }*/

    /*********************************
     * Show sticky bar
     ********************************/
    const productButtons = document.querySelector('.product-buttons-group');
    const productSticky = document.querySelector('.sticky-line');
    const footerTop = document.querySelector('.site-footer').offsetTop;

    if (productButtons) {
        const add_class_on_scroll = () => productSticky.classList.add("show");
        const remove_class_on_scroll = () => productSticky.classList.remove("show");

        setTimeout(() => {
            const sectionProductHeight = productButtons.offsetHeight;
            const sectionProductTop = productButtons.getBoundingClientRect().top + window.pageYOffset;
            const productButtonsPosition = sectionProductTop + sectionProductHeight;

            window.addEventListener('scroll', function () {
                window.scrollY > productButtonsPosition && window.scrollY < footerTop
                    ? add_class_on_scroll()
                    : remove_class_on_scroll();
            })
        }, 1000);
    }

    /*********************************
     * Sticky product add to cart
     ********************************/
    const stickyButton = document.querySelector('.sticky-add-cart');
    const productButton = document.querySelector('.product-add-cart')

    if (stickyButton) {
        stickyButton.addEventListener('click', (e) => {
            e.preventDefault();
            productButton.click();
            setTimeout(() => stickyButton.removeAttribute('disabled'), 1000)
        });
    }

    /*********************************
     * Hide Accordions By DTK from gift product
     ********************************/
    const productName = document.querySelector('.product-single__details .product__title').innerHTML;
    if (productName.toLowerCase() === 'ETOILE E-GIFT CARD'.toLowerCase()) {

        const DTKaccordion = document.querySelector('.product__block.product__accordions');
        DTKaccordion ? DTKaccordion.remove() : '';
    }
});